/* eslint-disable no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable no-useless-return */
/* eslint-disable prefer-const */
import SquareIcon from "@mui/icons-material/Square";
import { useTheme } from "@mui/material/styles";
import { Box } from "@mui/system";
import { Chart } from "chart.js";
import "chart.js/auto";
import React from "react";
import { Line } from "react-chartjs-2";
import { FormattedMessage } from "react-intl";
import {
  AnalysisQuizPointRate,
  AnalysisQuizYourPoint
} from "../../../../../public/assets/icons/AnalysisQuizNote";
import { TTheme } from "../../../../utils/configs/setupTheme";

function AnalysisGeneral({ scoreRange, isIpad }: any) {
  const theme: TTheme = useTheme();
  const getDataAnalyze = () => {
    let tempDataChart: any = [];
    tempDataChart = Array(101)
      .fill(false)
      .map((ele, index) => {
        const existRange2 = scoreRange?.range_list?.filter(
          (el: { correct_questions: number }) =>
            Number(
              Number(
                (el.correct_questions / scoreRange.finished_questions) * 100
              ).toFixed(0)
            ) === index
        );
        let memberCount = 0;
        existRange2?.forEach((v: { count: number }) => {
          memberCount += v.count;
        });
        return {
          member: existRange2 && existRange2.length > 0 ? memberCount : null,
          score: index,
          correct_questions:
            existRange2 && existRange2.length > 0
              ? existRange2?.[0]?.correct_questions
              : null
        };
      });
    return tempDataChart;
  };

  const getXUserValue = () => {
    const dataRange = getDataAnalyze() || [];
    if (scoreRange?.correct_questions >= 0) {
      return (
        dataRange.find(
          (v: { correct_questions: any }) =>
            v.correct_questions === scoreRange?.correct_questions
        )?.score || 0
      );
    }
    return 0;
  };
  const getYUserValue = () => {
    const dataRange = getDataAnalyze() || [];
    if (scoreRange?.correct_questions >= 0) {
      return (
        dataRange.find(
          (v: { correct_questions: any }) =>
            v.correct_questions === scoreRange?.correct_questions
        )?.member || 0
      );
    }
    return 0;
  };

  const dataChart = getDataAnalyze();
  const data = {
    labels: dataChart.map((ele: { score: any }) => ele.score),
    datasets: [
      {
        fill: false,
        data: dataChart.map((ele: { member: any }) => ele.member),
        // backgroundColor: "#FEDF3F",
        borderColor: "#FEDF3F",
        pointBorderColor: theme.palette.secondary.main,
        pointBackgroundColor: theme.palette.secondary.main,
        borderWidth: 1,
        pointRadius: 2,
        spanGaps: true,
        tension: 0.4
      },
      {
        data: [
          {
            y: getYUserValue(),
            x: getXUserValue()
          }
        ],
        backgroundColor: theme.palette.primary.main
        // pointBackgroundColor: "#38B000"
      }
    ]
  };
  const lineOptions: any = {
    horizontalLine: [
      {
        y: getYUserValue() === 0 ? 0.1 : getYUserValue(), // fix case = 0 not show lines
        x: getXUserValue() === 0 ? 0.1 : getXUserValue(),
        style: theme.palette.primary.main
      }
    ],
    plugins: {
      legend: {
        display: false
      },
      tooltip: {
        displayColors: false,
        callbacks: {
          label: (context: {
            dataset: { label: string };
            parsed: { y: null };
          }) => {
            let label = context.dataset.label || "";
            if (label) {
              label += ": ";
            }
            if (context.parsed.y !== null) {
              label += `${context.parsed.y} người`;
            }
            return label;
          },
          title: (context: { parsed: { x: any } }[]) => {
            const xValue = context?.[0]?.parsed.x;
            return `${Number(xValue / 10)} điểm`;
          }
        }
      }
    },
    scales: {
      y: {
        title: {
          display: true,
          text: "Tổng người làm bài",
          align: "end",
          font: {
            size: 10
          }
        },
        display: true,
        position: "left",
        min: 0,
        max: scoreRange.num_of_members > 10 ? scoreRange.num_of_members : 10,
        ticks: {
          stepSize: scoreRange.num_of_members > 10 ? 1 : 2,
          autoSkip: false,
          callback: (value: number, _index: any) => {
            return (scoreRange.num_of_members <= 10 && value > 0) ||
              (value > 0 &&
                value % Math.floor(scoreRange.num_of_members / 5) === 0 &&
                value / Math.floor(scoreRange.num_of_members / 5) < 5) ||
              value === scoreRange.num_of_members
              ? value
              : "";
          }
        },
        grid: {
          drawBorder: true,
          borderDash: [4, 2],
          color: (context: { tick: { value: number } }) => {
            return scoreRange.num_of_members <= 10 ||
              (context.tick.value %
                Math.floor(scoreRange.num_of_members / 5) ===
                0 &&
                context.tick.value / Math.floor(scoreRange.num_of_members / 5) <
                  5) ||
              context.tick.value === scoreRange.num_of_members
              ? theme.palette.primary.gray
              : null;
          }
        }
      },
      x: {
        title: {
          display: true,
          text: "Điểm",
          align: "end",
          font: {
            size: 10
          }
        },
        ticks: {
          autoSkip: false,
          color: (context: { tick: { value: any } }) => {
            if (context.tick.value === (getXUserValue() || 0)) {
              return theme.palette.primary.gray400;
            }
            return theme.palette.primary.gray400;
          },
          callback: (value: number, _index: any) => {
            return value % 10 === 0 ? value / 10 : "";
          },
          font: { style: "initial" },
          maxRotation: 0
        },
        grid: {
          drawBorder: false,
          borderDash: [4, 2],
          color: () => {
            return null;
          }
        }
      },
      y1: {
        display: true,
        position: "right",
        min: 0,
        grid: {
          drawBorder: true,
          borderDash: [4, 2],
          color: () => {
            return null;
          }
        },
        max: scoreRange.num_of_members > 10 ? scoreRange.num_of_members : 10,
        ticks: {
          stepSize: 1,
          autoSkip: false,
          callback: (value: any, _index: any) => {
            return value === getYUserValue() ? value : null;
          },
          color: "#07A3FB"
        }
      }
    }
  };

  const horizontalLinePlugin: any = {
    id: "horizontalLine",
    afterDraw: (chartInstance: {
      scales: { y: any; x: any };
      options: { horizontalLine: string | any[] };
    }) => {
      const canvas = document.getElementById("my-chart") as any;
      let ctx = canvas?.getContext("2d");
      const yScale = chartInstance.scales?.y;
      const xScale = chartInstance.scales?.x;
      let index = 0;
      let line: any = 0;
      let style = "rgba(169,169,169, .6)";
      if (chartInstance.options.horizontalLine) {
        for (
          index = 0;
          index < chartInstance.options.horizontalLine.length;
          index += 1
        ) {
          line = chartInstance.options.horizontalLine[index];
          let xValue = 0;
          let yValue = 0;
          if (!line.style) {
            style = "rgba(169,169,169, .6)";
          } else {
            style = line.style;
          }
          if (line.y) {
            yValue = yScale.getPixelForValue(line.y);
          } else {
            yValue = 0;
          }

          if (line.x) {
            xValue = xScale.getPixelForValue(line.x);
          } else {
            xValue = 0;
          }

          ctx.lineWidth = 1;

          if (yValue) {
            ctx.beginPath();
            ctx.setLineDash([2, 2]);
            ctx.moveTo(canvas.offsetWidth - 20, yValue);
            ctx.lineTo(xValue, yValue);
            ctx.lineTo(xValue, canvas.offsetHeight - 30);
            ctx.strokeStyle = style;
            ctx.stroke();
          }

          if (line.text) {
            ctx.fillStyle = style;
            ctx.fillText(line.text, 0, yValue);
          }
        }
        return;
      }
    }
  };

  Chart.register(horizontalLinePlugin);

  return (
    <Box
      style={{
        display: "flex",
        flexDirection: "column",
        padding: "16px 0px",
        width: "100%"
      }}
    >
      <span className="text-[18px] font-semibold mb-3">
        <FormattedMessage id="IDS_Analysis_General" />
      </span>
      <div className="min-h-[135px] pt-1">
        <Line
          data={data}
          options={lineOptions}
          id="my-chart"
          plugins={[horizontalLinePlugin]}
        />
      </div>
      <Box className="mt-1 flex md:gap-x-3">
        <div className="text-[13px] font-[500] text-gray400 flex sm:w-[64px] md:w-[90px]">
          <FormattedMessage id="IDS_Note" />:
        </div>
        <div className="flex flex-col text-[10px] font-normal gap-y-4 mt-[2px]">
          <div className="flex sm:gap-2 lg:gap-4 items-center">
            <AnalysisQuizPointRate />
            <span>
              <FormattedMessage id="topicAnalysis.pointRate" />
            </span>
          </div>
          <div className="flex sm:gap-2 lg:gap-4 items-center">
            <AnalysisQuizYourPoint />
            <span>
              <FormattedMessage id="topicAnalysis.yourPoint" />
            </span>
          </div>
          <div className="flex items-center sm:gap-2 lg:gap-4">
            <span className="text-[12px] text-blue1 sm:w-[70px] md:w-[85px] text-center">
              {getYUserValue()}
            </span>
            <span className="md:ml-4 lg:ml-0">
              <FormattedMessage id="topicAnalysis.memberSamePoint" />
            </span>
          </div>
        </div>
      </Box>
    </Box>
  );
}
export default React.memo(AnalysisGeneral);
